import ApiService from "@/core/services/api.service";

export default {
  state: {
    allowSuffix: [
      "pdf",
      "doc",
      "docx",
      "rar",
      "zip",
      "jpg",
      "png",
      "jpeg",
      "gif",
      "svg",
      "bmp",
      "tiff",
      "ico",
      "pjpeg",
      "x-png",
      "xls",
      "xlsx",
    ],

    jobseekerResume: null,
  },

  getters: {
    allowSuffix(state) {
      return state.allowSuffix;
    },

    jobseekerResume(state) {
      return state.jobseekerResume;
    },
  },

  mutations: {
    saveJobseekerResume(state, data) {
      let resume = JSON.parse(JSON.stringify(data));

      const personalData = {};
      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          personalData[key] = value;
        }
      });
      state.jobseekerResume = {
        contact: resume.contact || {},
        course: resume.courses,
        honor: resume.honors,
        jobExperience: resume.jobExperience,
        language: resume.languages,
        project: resume.projects,
        skill: resume.skills,
        educationalBackground: resume.educationalBackground,
        personalData,
      };
    },

    removeJobseekerResume(state) {
      state.jobseekerResume = null;
    },
  },

  actions: {
    jobseekerResume(context) {
      return new Promise((resolve, reject) => {
        ApiService.setHeader("jobseeker");
        ApiService.get("api/v2/jobseeker/resume")
          .then(({ data }) => {
            context.commit("saveJobseekerResume", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
